import React from "react"
import styled, { keyframes } from "styled-components"
import { Link } from "gatsby"
import { PlayerCardData, ComponentData } from "../../data/ChildHeroSectionData"

export default function PlayerCard() {
  return (
    <>
      {/* this is container */}
      <PlayerWrapper>
        {/* Child */}
        <PlayerWrapperFirstChild>
          <CurriculumWrapper>
            <CurriculumText>Featured Documentation Item</CurriculumText>
            <CurriculumWrapperContainer>
              {PlayerCardData.map(item => {
                return (
                  <>
                    <Link to={item.route}>
                      <SectionRowWrapper>
                        <SectionRowNumber>
                          <SectionRowNumberParagraph>
                            {item.number}
                          </SectionRowNumberParagraph>
                        </SectionRowNumber>
                        <SectionRowTextWrapper>
                          <SectionRowTextWrapperParagraph>
                            {item.title}
                          </SectionRowTextWrapperParagraph>
                          <SectionRowTextWrapperSubtitle>
                            {item.description}
                          </SectionRowTextWrapperSubtitle>
                          <ReadComponentWrapper>
                            {item.property}
                          </ReadComponentWrapper>
                        </SectionRowTextWrapper>
                      </SectionRowWrapper>
                    </Link>
                  </>
                )
              })}
            </CurriculumWrapperContainer>
          </CurriculumWrapper>
          <div style={{ cursor: "pointer" }}>
            <CardImageWrapper>
              <BackgroundWrapper>
                <div
                  style={{
                    transition:
                      "all 0.8s cubic-bezier(0.075, 0.82, 0.165, 1) 0s",
                  }}
                >
                  <ImageBackgroundWrapper
                    src="https://images.ctfassets.net/ooa29xqb8tix/3PHS4tm6Xw2BEZ1WWIjwnk/24fa4d723fb257dcf480b2e487afef42/React_Hooks_handbook_200x150_cover_new.svg"
                    alt=""
                  />
                </div>
              </BackgroundWrapper>
              <BackgroundText>
                <BackgroundTextParagraph>
                  Getting started with Veu CSS
                </BackgroundTextParagraph>
                <BackgroundTextSubtitle>Documentation</BackgroundTextSubtitle>
              </BackgroundText>
            </CardImageWrapper>
          </div>
        </PlayerWrapperFirstChild>
      </PlayerWrapper>
      <PlayerWrapper style={{ marginLeft: "150px" }} className="respo">
        {/* Child */}
        <PlayerWrapperFirstChild>
          <div style={{ cursor: "pointer" }}>
            <CardImageWrapper>
              <BackgroundWrapper>
                <div
                  style={{
                    transition:
                      "all 0.8s cubic-bezier(0.075, 0.82, 0.165, 1) 0s",
                  }}
                >
                  <ImageBackgroundWrapper
                    src="https://images.ctfassets.net/ooa29xqb8tix/6BIofDHiSke9fVe3YYd4qk/a6b91742de92ee418f22d53120ea32e4/SwiftUI_Livestream_200x150_cover_new.svg"
                    alt=""
                  />
                </div>
              </BackgroundWrapper>
              <BackgroundText>
                <BackgroundTextParagraph>
                  Beautiful UI components
                </BackgroundTextParagraph>
                <BackgroundTextSubtitle>Components</BackgroundTextSubtitle>
              </BackgroundText>
            </CardImageWrapper>
          </div>
          <CurriculumWrapper>
            <CurriculumText>Featured Documentation Item</CurriculumText>
            <CurriculumWrapperContainer>
              {ComponentData.map(item => {
                return (
                  <>
                    <Link to={item.route}>
                      <SectionRowWrapper>
                        <SectionRowNumber>
                          <SectionRowNumberParagraph>
                            {item.number}
                          </SectionRowNumberParagraph>
                        </SectionRowNumber>
                        <SectionRowTextWrapper>
                          <SectionRowTextWrapperParagraph>
                            {item.title}
                          </SectionRowTextWrapperParagraph>
                          <SectionRowTextWrapperSubtitle>
                            {item.description}
                          </SectionRowTextWrapperSubtitle>
                          <ReadComponentWrapper>
                            {item.property}
                          </ReadComponentWrapper>
                        </SectionRowTextWrapper>
                      </SectionRowWrapper>
                    </Link>
                  </>
                )
              })}
            </CurriculumWrapperContainer>
          </CurriculumWrapper>
        </PlayerWrapperFirstChild>
      </PlayerWrapper>
    </>
  )
}

const ImageAnimation = keyframes`
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
`

const PlayerWrapper = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  gap: 20px;
  justify-items: center;
  max-width: 1234px;
  margin: 40px auto;
  width: 100%;
  box-sizing: border-box;
  pointer-events: visible;

  @media (max-width: 1234px) {
    gap: 20px;
  }
`

const PlayerWrapperFirstChild = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: auto auto;
  column-gap: 20px;
  width: 586px;
  height: 400px;
  padding: 20px;
  background: rgba(255, 255, 255, 0.6);
  border-radius: 20px;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 0px 0.5px inset;
`

const CurriculumWrapper = styled.div`
  position: relative;
  width: 287px;
  height: 323px;
`

const CurriculumText = styled.p`
  font-style: normal;
  font-size: 13px;
  line-height: 130%;
  color: rgba(0, 0, 0, 0.7);
  text-transform: uppercase;
  font-weight: 600;
  margin: 0px;
`

const CurriculumWrapperContainer = styled.div`
  display: grid;
  gap: 8px;
  width: 287px;
  height: 100%;
  margin-top: 20px;
  overflow: hidden scroll; // check next time
  -webkit-mask-image: linear-gradient(
    rgb(255, 255, 255) 80%,
    rgba(255, 255, 255, 0) 100%
  );
  .link_R {
    width: 100%;
    text-decoration: none;
  }
  ::-webkit-scrollbar {
    display: none;
  }
`

const SectionRowWrapper = styled.div`
  *,
  & {
    transition: all 0.8s cubic-bezier(0.075, 0.82, 0.165, 1) 0s;
  }

  position: relative;
  display: grid;
  grid-template-columns: 46px auto;
  gap: 10px;
  width: 100%;
  min-width: 220px;
  padding: 10px;
  border-radius: 10px;

  :hover {
    background: rgba(68, 66, 178, 0.1);
    box-shadow: rgba(68, 66, 178, 0.2) 0px 0px 0px 0.5px inset;
  }
`

const SectionRowNumber = styled.div`
  width: 36px;
  height: 36px;
  background: rgba(68, 66, 178, 0.1);
  border-radius: 50px;
`

const SectionRowNumberParagraph = styled.p`
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 140%;
  text-align: center;
  margin: 4px 0px 0px;
  color: rgb(0, 0, 0);
`

const SectionRowTextWrapper = styled.div`
  display: grid;
  gap: 8px;
  align-self: center;
`

const SectionRowTextWrapperParagraph = styled.p`
  font-style: normal;
  font-size: 15px;
  max-width: 160px;
  line-height: 18px;
  color: rgb(0, 0, 0);
  font-weight: 600;
  margin: 0px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  padding-right: 40px;
`

const SectionRowTextWrapperSubtitle = styled.p`
  font-style: normal;
  font-size: 15px;
  line-height: 18px;
  color: rgba(0, 0, 0, 0.7);
  margin: 0px;
  overflow: hidden;
  font-weight: normal;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`

const ReadComponentWrapper = styled.p`
  font-weight: normal;
  font-style: normal;
  font-size: 13px;
  line-height: 130%;
  position: absolute;
  width: 48px;
  height: 20px;
  background: rgba(68, 66, 178, 0.1);
  color: black;
  border-radius: 5px;
  text-align: center;
  margin: 0px;
  padding-top: 2px;
  top: 10px;
  right: 10px;
`

const CardImageWrapper = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr 1fr;
  min-width: 200px;
  height: 360px;
  border-radius: 20px;
  background: linear-gradient(
    209.21deg,
    rgb(96, 3, 139) 13.57%,
    rgb(26, 172, 204) 98.38%
  );
  box-shadow: rgba(26, 172, 204, 0.3) 0px 20px 40px,
    rgba(0, 0, 0, 0.05) 0px 1px 3px;
  padding: 20px;
  transition: all 0.8s cubic-bezier(0.075, 0.82, 0.165, 1) 0s;

  @media screen and (-webkit-min-device-pixel-ratio: 0) and (min-resolution: 0.001dpcm) {
    box-shadow: none;
  }
  :hover {
    box-shadow: rgba(26, 172, 204, 0.3) 0px 20px 80px,
      rgba(0, 0, 0, 0.15) 0px 20px 40px;
    transform: scale(1.1);
  }
`

const BackgroundWrapper = styled.div`
  position: relative;
  display: grid;
  justify-content: center;
  jutsify-items: center;
  height: 150px;
`

const ImageBackgroundWrapper = styled.img`
  height: 150px;
  margin: 0px;
  opacity: 0;
  animation: 1s ease 0s 1 normal forwards running ${ImageAnimation};
`

const BackgroundText = styled.div`
  position: relative;
  padding-top: 20px;
`

const BackgroundTextParagraph = styled.p`
  font-style: normal;
  font-size: 24px;
  line-height: 140%;
  font-weight: bold;
  text-align: center;
  color: white;
  margin: 0px;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
`

const BackgroundTextSubtitle = styled.p`
  font-style: normal;
  color: rgba(255, 255, 255, 0.7);
  font-weight: normal;
  font-size: 15px;
  line-height: 18px;
  text-align: center;
  margin: 10px 0px 0px;
`
